import { ClientService } from '../services/client.service'
import { clientConstants } from '../constants/client.constants'

/**
 * Loads the client's points information
 * @param {function} dispatch The redux dispatcher
 */
const getPointsInformation = () => dispatch => {
	dispatch({
		type: clientConstants.LOADING_POINTS
	})

	Promise.all([getBalancePoints(dispatch), getExpiringPoints(dispatch)]).then(
		() => {
			dispatch({
				type: clientConstants.POINTS_WAS_LOADED
			})
		}
	)
}

const getBalancePoints = async dispatch => {
	return ClientService.getBalancePoints()
		.then(({ data: points }) => {
			dispatch({
				type: clientConstants.GET_BALANCE_POINTS,
				payload: points
			})
		})
		.catch(() => {
			dispatch({
				type: clientConstants.GET_BALANCE_POINTS,
				payload: null
			})
		})
}

const getExpiringPoints = async dispatch => {
	return ClientService.getClientPointsExpiringIn(30)
		.then(({ data: points }) => {
			dispatch({
				type: clientConstants.GET_EXPIRING_POINTS,
				payload: points
			})
		})
		.catch(() => {
			dispatch({
				type: clientConstants.GET_EXPIRING_POINTS,
				payload: null
			})
		})
}

const getAvailablePointsToBuy = () => async dispatch => {
	return ClientService.getAvailablePointsToBuy()
		.then(({ data: remainingAnualPoints }) => {
			dispatch({
				type: clientConstants.GET_ABAILABLE_POINTS_TO_BUY,
				payload: remainingAnualPoints
			})
		})
		.catch(() => {
			dispatch({
				type: clientConstants.GET_ABAILABLE_POINTS_TO_BUY,
				payload: null
			})
		})
}

export const clientActions = {
	getPointsInformation,
	getAvailablePointsToBuy
}
